// initialed state
export const initialState = () => ({
	data: {},
	activeFetch: false,
	credentialsSuggestions: {},
	projectCredentials: {}, // dict project id to credentials
	lockedCredentialsData: {}, //dict workflow id to locked credentials data
	userMatching: {}, //dict of credentials to its user matching data
});

const state = initialState();

export default state;
